<template>
  <div class="row">
    <div class="col-md-12">
      <div class="d_flex_btwn">
        <h5 class="common_subtitle font_16p">List of Payment Methods</h5>
      </div>

      <div class="d_flex_start pt_10 pb_10">
        <button
            type="button" class="btn btn-outline-primary btn-sm mr_15 width_200p"
            @click="openPaymentModal()"
        >
          Add New Payment Method
        </button>
<!--        <button
            type="button"
            class="btn btn-outline-primary btn-sm mr_15 width_100p"
            @click.prevent="openPaymentModal(selectedRecord.id)"
            :disabled="!selectedRecord || !selectedRecord.id"
        >
          Edit
        </button>-->
        <button
            type="button"
            class="btn btn-outline-danger btn-sm mr_15 width_100p"
            @click.prevent="deleteRecord()"
            :disabled="!selectedRecord || !selectedRecord.id"
        >
          Delete
        </button>
<!--
        <button type="button" class="btn btn-outline-info btn-sm mr_15 width_260p"
                @click.prevent="viewPermission(selectedRecord)" :disabled="!selectedRecord || !selectedRecord.id">View
          Permission
        </button>-->
      </div>

      <cloud-table-component
          :columns="columns"
          :rows="records"
          :sortable="sortable"
          :pagination="pagination"
          @sorting="sorting"
          @pageChanged="pageChanged">

        <template v-slot:id="{ row }">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" :id="'action_'+row.id"
                   @focus="checkSingleData(row, $event)" :checked="selectedRecord?.id === row.id">
            <label class="form-check-label" :for="'action_'+row.id"></label>
          </div>
        </template>

        <template v-slot:is_default="{ row }">
          <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                :id="'is_default_'+row.id"
                @focus="checkIsDefaultSingleData(row, $event)"
                :checked="row.is_default"
                :disabled="row.is_default">
            <label class="form-check-label" :for="'is_default_'+row.id"></label>
          </div>
<!--          <span v-if="row.is_default" class="color_warning">Default</span>
          <span v-else class="color_warning">No</span>-->
        </template>

      </cloud-table-component>
    </div>

    <BaseModal
        v-if="isShowModal"
        :title="modalTitle"
        :closeModal="closePaymentModal"
        size="modal_850p"
    >
      <PaymentMethodForm
          :closeModal="closePaymentModal"
          :loadData="loadData"
          :editId="editId"
      />
    </BaseModal>

  </div>
</template>

<script>

import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import PaymentMethodForm from "@/views/account/PaymentMethodForm.vue";
import BaseModal from "@/components/BaseModal.vue";

export default {
  name: 'PaymentMethodList',
  components: {BaseModal, PaymentMethodForm, CloudTableComponent},
  props: ['closeModal'],
  data() {
    return {
      lyLoading: false,
      form: {
        type: '',
      },
      records: [],
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "Payment Method",
          field: "name",
          sortable: true,
        },
        {
          label: "Is Default",
          field: "is_default",
          sortable: true,
          slot: true,
        },
      ],
      pagination: null,
      isShowModal: false,
      editId: false,
      selectedRecord: null,
    }
  },
  computed: {
    modalTitle(){
      if (this.editId) {
        return 'Edit Payment Method';
      } else {
        return 'Add New Payment Method';
      }
    }
  },
  created() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/customer-payment-methods', {
        params: { ...this.queryParams, ...this.filter }
      })
          .then(({data}) => {
            this.records = data.data
            this.pagination = data.meta;
          })
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post('/customer-payment-methods', this.form)
          .then(({ data }) => {
            if (data.success) {
              this.loadData()
              this.showSuccessMsg(data.message);
              this.closePaymentModal()
            } else {
              this.showFailMsg(data.message);
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    openPaymentModal(editId = null){
      this.editId = editId
      this.isShowModal = true;
    },
    closePaymentModal(){
      this.isShowModal = false;
    },
    checkSingleData(user, event) {
      event.target.blur();
      if (this.selectedRecord?.id === user.id) {
        this.selectedRecord = null;
      } else {
        this.selectedRecord = user;
      }
    },
    checkIsDefaultSingleData(data, event) {
      event.target.blur();
      this.axios.post(`/change-customer-payment-methods-status/${data.id}`)
          .then(({ data }) => {
            if (data.success) {
              this.showSuccessMsg(data.message);
              this.loadData()
            } else {
              this.showFailMsg(data.message)
            }
          })
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/customer-payment-methods/' + this.selectedRecord.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedRecord = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.showFailMsg(response.data.message)
                }
              });
        }
      });
    },
  }
}
</script>
<style scoped>

</style>
  